// Run low-priority work once the browser is idle, but never later than `timeoutMs`.
// Used to keep non-critical requests (extra ad creatives, preroll warm-up) from landing in the
// same instant as the first search results and competing for the browser's connections.
export function whenIdle(fn: () => void, timeoutMs = 2000) {
  if (typeof window === "undefined") return
  const ric = (window as unknown as { requestIdleCallback?: (cb: () => void, o: { timeout: number }) => number }).requestIdleCallback
  // Wrapped so fn never receives requestIdleCallback's IdleDeadline argument.
  if (ric) ric(() => fn(), { timeout: timeoutMs })
  else setTimeout(fn, Math.min(timeoutMs, 1000))
}
